import { openCompanyPage } from "@utils/navigation.util";
import { ICompanyTagResponse } from "@interfaces/responses.interface";
import { CompanyAvatar, CompanyAvatarSizes } from "@ui/Avatars/CompanyAvatar";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: ICompanyTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: ICompanyTagResponse) => void;
  onRemove: (tag: ICompanyTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function CompanyTag({ data, isDisabled, onAdd, onRemove, withPlusIcon, iconOnly }: Props) {
  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      isSuggestedTag={data?.is_suggested}
      onRemove={onRemove}
      onRedirect={() => openCompanyPage(data.object.id)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <CompanyAvatar
        size={CompanyAvatarSizes.SMALL}
        classNames="rounded-[5px] w-5 h-5 border border-gray-200 bg-background-clear flex-shrink-0"
        logoUrl={data.object.logo}
      />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.title}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
